import React, { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: "Aakash",
    company: "Diamond Modular",
    comment: "Instaship has become our one-stop solution for all logistic needs — PTL, FTL, reverse logistics. We no longer juggle multiple vendors. Delivery times are down 30%, costs are lower, and daily pickups run without hassle.",
    rating: 5,
    initials: "A",
  },
  {
    name: "Mehul Setia",
    company: "Setia Pipes",
    comment: "Daily management of our shipments used to be a nightmare. Shifting our logistics to Instaship has been a game changer - now I can focus on growing the business instead of chasing transporters for updates.",
    rating: 5,
    initials: "MS",
  },
  {
    name: "Rahul",
    company: "GEE EMM Industries",
    comment: "Reverse logistics used to be our biggest headache — delayed shipments, missing pickups, zero visibility. Instaship took complete ownership of it. Now I ship with full trust, knowing every return is tracked and handled professionally.",
    rating: 5,
    initials: "R",
  },
];

const Testimonials: React.FC = () => {
  const [active, setActive] = useState(0);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 940);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 940);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startAutoPlay = () => {
    intervalRef.current = setInterval(() => {
      setActive(prev => (prev + 1) % testimonials.length);
    }, 15000);
  };

  useEffect(() => {
    startAutoPlay();
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goTo = (idx: number) => {
    setActive(idx);
    if (intervalRef.current) clearInterval(intervalRef.current);
    startAutoPlay();
  };

  const t = testimonials[active];

  return (
    <section style={{ background: '#f8fafc', padding: isMobile ? '32px 20px' : '52px 24px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? 22 : 32 }}>
          <p style={{ fontSize: 13, fontWeight: 600, letterSpacing: '0.12em', color: '#3498db', textTransform: 'uppercase', marginBottom: 8 }}>
            Testimonials
          </p>
          <h2 style={{ fontSize: isMobile ? '1.45rem' : '2rem', fontWeight: 800, color: '#0F172A', letterSpacing: '-0.03em', margin: 0 }}>
            Trusted by businesses across India
          </h2>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: 20,
          border: '1px solid #e8eef4',
          boxShadow: '0 8px 40px rgba(52,152,219,0.08)',
          padding: isMobile ? '24px 20px' : '32px 44px',
          textAlign: 'center',
          minHeight: 0,
          position: 'relative',
          transition: 'all 0.4s ease',
        }}>
          <div style={{ fontSize: 44, color: '#e1f0ff', lineHeight: 1, marginBottom: 4, fontFamily: 'Georgia, serif' }}>"</div>
          <div style={{ marginBottom: 12, color: '#F59E0B', fontSize: 17, letterSpacing: 2 }}>
            {'★'.repeat(t.rating)}{'☆'.repeat(5 - t.rating)}
          </div>
          <p style={{
            fontSize: isMobile ? 14.5 : 16,
            color: '#334155',
            lineHeight: 1.7,
            fontStyle: 'italic',
            maxWidth: 620,
            margin: '0 auto 20px',
          }}>
            "{t.comment}"
          </p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14 }}>
            <div style={{
              width: 48, height: 48, borderRadius: '50%',
              background: 'linear-gradient(135deg, #3498db, #2980b9)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontWeight: 700, fontSize: 16,
            }}>
              {t.initials}
            </div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontWeight: 700, color: '#0F172A', fontSize: 15 }}>{t.name}</div>
              <div style={{ fontSize: 13, color: '#64748b' }}>{t.company}</div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 18 }}>
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              style={{
                width: i === active ? 28 : 10,
                height: 10,
                borderRadius: 5,
                border: 'none',
                cursor: 'pointer',
                background: i === active ? '#3498db' : '#cbd5e1',
                transition: 'all 0.3s ease',
                padding: 0,
              }}
            />
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 12 }}>
          <button
            onClick={() => goTo((active - 1 + testimonials.length) % testimonials.length)}
            style={{
              width: 40, height: 40, borderRadius: '50%', border: '1px solid #e2e8f0',
              background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: '#64748b', fontSize: 18, lineHeight: 1,
            }}
          >&#x2039;</button>
          <button
            onClick={() => goTo((active + 1) % testimonials.length)}
            style={{
              width: 40, height: 40, borderRadius: '50%', border: '1px solid #e2e8f0',
              background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: '#64748b', fontSize: 18, lineHeight: 1,
            }}
          >&#x203a;</button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
